export default "__VITE_ASSET__BcYh6JAC__"